module.exports = __webpack_public_path__ + "img/calendar-30_fill.7eb11cdc.svg";